import { Css, useComputed, useTestIds } from "@homebound/beam";
import { type ReactNode } from "react";
import { type ObjectState } from "src/utils/formState";
import { type AiFieldProposalFormValue } from "./utils/aiFieldProposalForm";
import { isAiProposedDeletion } from "./utils/bindAiProposal";

type AiProposalValueProps = {
  aiProposal: ObjectState<AiFieldProposalFormValue> | undefined;
  originalValue: ReactNode;
  children: ReactNode;
};

/** Shows the saved value as removed instead of an editable field for entity DELETE proposals. */
export function AiProposalValue(props: AiProposalValueProps) {
  const { aiProposal, originalValue, children } = props;
  const tid = useTestIds(props, "removedValue");
  const isDeletion = useComputed(() => isAiProposedDeletion(aiProposal), [aiProposal]);
  // Beam's public fields overwrite originalValue when proposedValue is absent. Keep the static
  // removal treatment here until Beam supports original-only proposals through those public APIs.
  return isDeletion ? (
    <span {...tid} css={Css.tdlt.gray700.$}>
      {originalValue}
    </span>
  ) : (
    <>{children}</>
  );
}
